import { render, staticRenderFns } from "./StoreRestDayRuleManage.vue?vue&type=template&id=1c925ddd&scoped=true&"
import script from "./StoreRestDayRuleManage.vue?vue&type=script&lang=js&"
export * from "./StoreRestDayRuleManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c925ddd",
  null
  
)

export default component.exports